import React from 'react';

const EventCalendar = () => {
    return (
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h2 className="text-3xl text-center font-bold text-gray-800 mb-6 pb-3 border-b-4 border-blue-600">
                CALENDAR
            </h2>
            <div className="overflow-hidden rounded-xl shadow-md">
                <iframe
                    src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Asia%2FMakassar&hl=id&src=aWQuaW5kb25lc2lhbiNob2xpZGF5QGdyb3VwLnYuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%230b8043" style={{ width: '100%', height: '600px' }}
                    loading="lazy"
                    // frameBorder="0"
                    // scrolling="no"
                    title="Google Calendar Jadwal Acara"
                ></iframe>
            </div>
        </div>
    );
};

export default EventCalendar;